import * as API from '../api'

export const FETCHING_AREA_FDS = 'FETCHING_AREA_FDS'
export const FETCH_AREA_FDS = 'FETCH_AREA_FDS'
export const FETCH_AREA_FDS_ERROR = 'FETCH_AREA_FDS_ERROR'

export const fetchAreaFds = token => {
  return dispatch => {
    dispatch({ type: FETCHING_AREA_FDS })

    return API.areaFds
      .getAreaFds(token)
      .then(response => {
        const { area, fds } = response.data

        dispatch({ type: FETCH_AREA_FDS, area, fds })
      })
      .catch(err => {
        // 404 é token inexistente ou regerado: o QR impresso não vale mais, e tentar de
        // novo não adianta. Qualquer outro erro (rede, timeout) admite nova tentativa.
        const notFound = err.response && err.response.status === 404

        dispatch({ type: FETCH_AREA_FDS_ERROR, error: notFound ? 'invalid' : 'failed' })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/areaFds.js